export default {
	methods: {
		redirectTo (value) {
			this.$router.push(value).catch(()=>{})
		}
	}
}
